/** Cover image rules, same as the API (`POST /events/cover-image`). */
export const COVER_MAX_BYTES = 8 * 1024 * 1024
export const COVER_ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const

export type CoverImageError = 'coverType' | 'coverSize'

/** Client-side pre-check; the server checks again. */
export function coverImageError(file: { type: string; size: number }): CoverImageError | null {
  if (!(COVER_ACCEPTED_TYPES as readonly string[]).includes(file.type)) return 'coverType'
  if (file.size > COVER_MAX_BYTES) return 'coverSize'
  return null
}

/** Approximate decoded size of a `data:` URI (native picker). */
export const dataUriBytes = (uri: string): number =>
  Math.floor(((uri.split(',')[1] ?? '').length * 3) / 4)
